import * as angular from 'angular';

import DatasetService from '../../services/dataset-service';
import template from './embed-component.html';
import { HelpDocsService } from '@mode/shared/util-js';

class ShareEmbedController {
  static $inject = ['$scope', 'DatasetService', '$window', '$timeout', 'EmbedKeyModel', 'HelpDocsService'];

  public report: any;
  public reportRun: any;
  public owner: any;
  public dismiss: () => void;

  private signedEmbedEnabled: boolean;
  private secretEmbedEnabled: boolean;
  private embedKey: any;

  private view: {
    embed: boolean;
    whiteLabel: boolean;
  };
  private toggles: {
    embedEnabled: boolean;
  };

  constructor(
    private $scope,
    private datasetService: DatasetService,
    private $window,
    private $timeout,
    private EmbedKeyModel,
    public helpDocs: HelpDocsService
  ) {}

  $onInit() {
    this.signedEmbedEnabled = this.report.canToggleSigning;
    this.secretEmbedEnabled = !this.report.public && (this.report.canToggleSecret || this.report.is_embedded);
    this.view = {
      embed: true,
      whiteLabel: false,
    };

    this.toggles = {
      embedEnabled: false,
    };

    this.report
      .embedKey()
      .then((embedKey) => {
        this.embedKey = embedKey;
        this.toggles.embedEnabled = !!embedKey;
        this.report.initEmbedKey(embedKey);
        this.reportRun.initEmbedKey(embedKey);
      })
      .catch(() => {
        // Probably deleted the key earlier, so just ignore this
      });
  }

  setView(view: 'embed' | 'whiteLabel') {
    this.view.embed = false;
    this.view.whiteLabel = false;
    this.view[view] = true;
  }

  enableSecretEmbed() {
    const confirm = this.$window.confirm('Are you sure you want to enable secret embeds?');
    if (confirm) {
      this.EmbedKeyModel.create({ report: this.report.token, params: {} }).then((embedKey) => {
        this.report.initEmbedKey(embedKey);
        this.reportRun.initEmbedKey(embedKey);
        this.embedKey = embedKey;
      });
    } else {
      this.toggles.embedEnabled = false;
    }
  }

  disableSecretEmbed() {
    const confirm = this.$window.confirm(
      'Are you sure you want to disable secret embeds?  This will permanently disable existing secret embeds for this report.'
    );
    if (confirm) {
      this.embedKey.destroy().then(() => {
        this.report.cleanupEmbedKey();
        this.reportRun.cleanupEmbedKey();
        this.embedKey = null;
      });
    } else {
      this.toggles.embedEnabled = true;
    }
  }

  toggleSignedEmbed() {
    this.report.toggleSignedEmbed(!this.report.is_signed);
  }
}

const ShareEmbedComponent: angular.IComponentOptions = {
  bindings: {
    reportRun: '<',
    report: '=',
    owner: '<',
    dismiss: '&',
  },
  template: template,
  controller: ShareEmbedController,
  controllerAs: 'ctrl',
};

angular.module('mode.components').component('shareEmbedComponent', ShareEmbedComponent);
